@if (childrenRoutes$ | async; as childrenRoutes) {
  @if (childrenRoutes.length > 0 || showMobileNavVersion) {
    <nav
      [class.compound-second-level-navbar]="!showMobileNavVersion"
      [class.compound-second-level-navbar-mobile]="showMobileNavVersion"
      [attr.aria-label]="'second_level_navbar_label' | translate"
    >
      <div class="container-fluid d-flex" [ngClass]="showMobileNavVersion ? 'g-4 py-1' : 'g-5 py-2'">
        <ng-container *ngTemplateOutlet="showMobileNavVersion ? mobileVersion : desktopVersion"></ng-container>
        @if (showChat$ | async) {
          <div class="ms-auto hide-small-viewport" *appHasPermissions="RequiredSecurities.AI_CHAT_Create_DP">
            <app-ai-chat-button></app-ai-chat-button>
          </div>
        }
      </div>
    </nav>
  }
  <ng-template #desktopVersion>
    @for (childRoute of childrenRoutes; track childRoute.routerLink) {
      <compound-navbar-link
        [navLink]="childRoute.routerLink"
        [isActive]="childRoute.isActive"
        [hasChildren]="childRoute.hasChildren"
        [ariaLabel]="childRoute.ariaLabel ? (childRoute.ariaLabel | translate) : null"
      >
        {{ childRoute.label | translate }}
      </compound-navbar-link>
    }
  </ng-template>
  <ng-template #mobileVersion>
    @if (hasAccessToLauncher) {
      <button
        ds-button
        id="switcher-button"
        data-test-id="switcher-button"
        class="top-nav-switcher-button"
        [attr.aria-label]="'switcher' | translate"
        [ds-tooltip]="'switcher' | translate"
        [tooltipPlacement]="DsTooltipPosition.bottom"
        (click)="openLauncher()"
      >
        <ds-icon [icon]="Icons.ListUl" [iconStyle]="IconStyles.Solid" class="top-nav-switcher-icon"></ds-icon>
      </button>
    }
    @if (currentContextItem$ | async; as contextItem) {
      <ds-breadcrumb
        [breadcrumbs]="[{ label: contextItem.label, rtLink: contextItem.routerLink }]"
        class="last-breadcrumb-link p-0"
      />
    }
  </ng-template>
  <ng-template #launcherModal>
    <app-switcher-modal></app-switcher-modal>
  </ng-template>
}
